import { createFileRoute } from '@tanstack/react-router'
import { WeeklyPlan } from '@/features/weekly-plan'

export const Route = createFileRoute('/weekly-plan')({
  component: WeeklyPlan,
})
